module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"about":"Über","posts":"Beiträge","community":"Community","guestbook":"Gästebuch","shop":"Shop"},"en":{"about":"About","posts":"Posts","community":"Community","guestbook":"Guestbook","shop":"Shop"}}')
  delete Component.options._Ctor
}
